<template>
  <div v-if="showModal" class="fixed inset-0 z-50 overflow-auto bg-smoke-light flex backdrop-blur-sm">
    <div class="relative p-8 bg-white w-full max-w-md m-auto flex-col flex rounded-xl shadow-2xl border border-red-50">
      <div class="flex flex-col items-center mb-6 text-center">
        <div class="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
          <svg class="h-8 w-8 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
        </div>
        <h2 class="text-xl font-bold text-gray-900 mb-2">Delete Job Posting</h2>
        <p class="text-sm text-gray-600 leading-relaxed">
          Are you sure you want to delete the posting for 
          <span class="font-bold text-gray-900">"{{ selectedJob ? selectedJob.title : '' }}"</span>?<br>
          <span class="text-red-700 mt-2 block font-medium">This action cannot be undone.</span>
        </p>
      </div>

      <ErrorMessage v-if="showError" :message="errorMessage" :duration="5000" class="mb-4" />

      <form @submit.prevent="confirmDelete" class="w-full">
        <div class="mb-6">
          <label class="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
            To confirm, type "delete" below
          </label>
          <input
            type="text"
            v-model="confirmationText"
            placeholder="Type 'delete' here"
            class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent text-[14px] transition-all bg-gray-50"
            required
            autocomplete="off"
          />
        </div>

        <div class="flex gap-4">
          <button
            type="button"
            class="flex-1 py-3 px-4 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold rounded-lg transition-colors border border-gray-200"
            @click="closeModal"
          >
            Cancel
          </button>
          <button
            type="submit"
            :class="[
              'flex-1 py-3 px-4 text-white font-bold rounded-lg shadow-lg transition-all',
              isConfirmationValid ? 'bg-red-600 hover:bg-red-700 active:transform active:scale-95' : 'bg-red-300 cursor-not-allowed opacity-50'
            ]"
            :disabled="!isConfirmationValid || loading"
          >
            <span v-if="loading" class="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full inline-block mr-2"></span>
            Delete
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import apiClient from "@/axios";
import ErrorMessage from "../messages/ErrorMessage.vue";

export default {
  name: "DeleteJobModal",
  components: {
    ErrorMessage,
  },
  props: {
    selectedJob: {
      type: Object,
      default: null,
    },
    showModal: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      confirmationText: "",
      showError: false,
      errorMessage: "",
      loading: false
    };
  },
  computed: {
    isConfirmationValid() {
      return this.confirmationText.toLowerCase() === "delete";
    },
  },
  methods: {
    closeModal() {
      this.confirmationText = "";
      this.showError = false;
      this.errorMessage = "";
      this.$emit("close");
    },
    async confirmDelete() {
      if (!this.isConfirmationValid || !this.selectedJob) return;

      this.loading = true;
      this.showError = false;
      this.errorMessage = "";

      try {
        await apiClient.delete(`/web/jobs/${this.selectedJob.id}`);
        this.$toast.success('Job posting deleted successfully');
        this.$emit("refresh");
        this.closeModal();
      } catch (error) {
        console.error("Error deleting job:", error);
        this.errorMessage = "Failed to delete job posting. Please try again later.";
        this.showError = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.smoke-light {
    background-color: rgba(0, 0, 0, 0.4);
}
</style>
